import React from 'react';

import type { Event } from '@vlabs/api/artemy/model';

import { useSelectedWorkspaceEvent } from '../useSelectedWorkspaceEvent';
import { EventPreviewFaceBody } from './event-preview';

interface EventType {
  event: Event;
}

export function EventPreview({
  event,
}: EventType): React.JSX.Element | null {
  const { setSelectedEvent, clearSelectedEvent, selectedEventId } = useSelectedWorkspaceEvent();

  const onClick = ({ event: $event }: EventType) => {
    if (selectedEventId === $event?.event_id) {
      clearSelectedEvent();
      return;
    }

    setSelectedEvent($event);
  };

  return (
    <EventPreviewFaceBody
      event={event}
      onClick={onClick}
    />
  );
}
